import api from "./api";

const signupUser = (accNo, bankCode, bvn, email, pNum, gender, password) => {
  const value = {
    gender: gender,
    emailAddress: email,
    phoneNumber: pNum,
    bvn: bvn || "",
    customerAccountNumber: accNo || "",
    customerBank: bankCode || "",
    password: password,
  };

  return api.post("/api/sign-up", value);
};

const verifyEmail = (emailAddress, otp) => {
  const value = {
    emailAddress: emailAddress,
    otp: otp,
  };

  return api.post("/api/complete-signup", value);
};

const setupTransactionPin = (pin) => {
  const value = { pin: pin };

  return api.post("/api/create-pin", value);
};
const resendOtp = (email) => {
  return api.post(`/api/resend-otp`, { email });
};

const userLogin = (email, password) => {
  const value = { email: email, password: password, channel: "web" };
  return api.post(`/api/login`, value);
};
const getVirtualAcc = () => {
  const value = {};
  return api.post(`/api/get-virtual-account`, value);
};

const requestToJoinApartment = (apartmentId) => {
  return api.post(
    `/api/request-to-join-apartment?apartmentClassId=${apartmentId}`,
  );
};
const createNextOfKin = (
  fullname,
  phonenumber,
  relationship,
  accountName,
  accountNumber,
  bank,
  email,
  homeAddress,
  gender,
) => {
  const value = {
    fullname,
    phonenumber,
    relationship,
    accountName,
    accountNumber,
    bank,
    email,
    homeAddress,
    gender,
  };
  return api.post(`/api/create-next-of-kin`, value);
};
const bankInfo = (accountNumber, bankName, transactionPin) => {
  const value = {
    accountNumber: accountNumber,
    bankName: bankName,
    transactionPin: transactionPin,
  };
  return api.post(`/api/edit-bank-info`, value);
};
const changePin = (newPin, oldPin) => {
  const value = { newPin: newPin, oldPin: oldPin };
  return api.post(`/api/change-pin`, value);
};

const changePassword = (emailAddress, oldPassword, newPassword) => {
  const value = {
    emailAddress: emailAddress,
    oldPassword: oldPassword,
    newPassword: newPassword,
  };
  return api.post(`/api/change-password`, value);
};
const resetPassword = (otp, newPassword, requestId, token) => {
  const value = { otp: otp, newPassword: newPassword, requestId: requestId };
  return api.post(`/api/reset-password`, value, {
    headers: { Authorization: token },
  });
};
const addBankAcc = (
  bankCode,
  accountNumber,
  accountName,
  bankName,
  transactionPin,
) => {
  const value = {
    bankCode: bankCode,
    accountNumber: accountNumber,
    accountName: accountName,
    bankName: bankName,
    transactionPin: transactionPin,
  };
  return api.post(`/api/create-customer-bank`, value);
};
const forgetPin = () => {
  const value = {};
  return api.post(`/api/forgot-pin`, value);
};
const resetPin = (otp, requestId, pin) => {
  const value = { otp: otp, requestId: requestId, newPin: pin };
  return api.post(`/api/reset-pin`, value);
};

const verifyBvn = (account_number, bank_code, bvn) => {
  const value = {
    account_number: account_number,
    bank_code: bank_code,
    bvn: bvn,
  };
  return api.post(`/api/verify-bvn`, value);
};

const validateBvn = (bvn) => {
  const value = {
    bvn: bvn,
  };
  return api.post(`/api/customer-validate-bvn`, value);
};
const fundWallet = (amount, email, transactionPin) => {
  const value = {
    amount: amount,
    callback_url: "string",
    email: email,
    transactionPin: transactionPin,
  };

  return api.post(`/api/fund-wallet`, value);
};
const Withdrawer = (amount, pin) => {
  const value = { amount: amount, transactionPin: pin };
  return api.post(`/api/initiate-transfer`, value);
};
const savings = (
  amount,
  duration,
  frequency,
  planName,
  transactionPin,
  type,
  deduction,
  startDate,
  recurring,
) => {
  const value = {
    savingsType: type,
    amountPerCycle: amount,
    savingsDuration: duration,
    savingsFrequency: frequency,
    planName: planName,
    pin: transactionPin,
    savingsDeduction: deduction,
    recurring: recurring,
    startDate: startDate,
  };

  return api.post(`/api/create-savings`, value);
};
const buyProject = (propertyId, numberOfUnits, pin) => {
  const value = {
    propertyId: Number(propertyId),
    numberOfUnits: Number(numberOfUnits),
    pin: pin.toString(),
  };
  return api.post(`/api/book-property`, value);
};

const financeAListing = (projectId, unit, pin) => {
  const value = {
    projectId: Number(projectId),
    unit: String(unit),
    pin: String(pin),
  };
  return api.post(`/api/finance-a-listing`, value);
};

const buyProperty = (projectId, units, transactionPin, method) => {
  const value = {
    paymentMethod: method,
    propertyId: projectId,
    units: units,
    transactionPin: transactionPin,
  };
  return api.post(`/api/buy-properties`, value);
};

const liquidate = (projectId, transactionPin, method) => {
  const value = {
    investmentId: projectId,
    requestType: method,
    transactionPin: transactionPin,
  };
  return api.post(`/api/liquidate-project`, value);
};

const deAccount = (emailAddress, password) => {
  const value = { emailAddress: emailAddress, password: password };
  return api.post(`/api/user-de-activate`, value);
};

const saveProduct = (id, type) => {
  const value = { propertyId: id, projectType: type };
  return api.post(`/api/add-property-buy-later`, value);
};

const addPropertyBuyLater = (propertyId) => {
  const value = { propertyId: propertyId.toString() };
  return api.post(`/api/add-property-buy-later`, value);
};

const validateAccount = (accountNumber, bankCode) => {
  const value = { accountNumber, bankCode };
  return api.post(`/api/validate-account`, value);
};
const removePropertyBuyLater = (propertyId) => {
  const value = { propertyId: propertyId.toString() };
  return api.post(`/api/remove-property-buy-later`, value);
};

const addProjectBuyLater = (propertyId) => {
  const parsedId = Number(propertyId);
  const value = { propertyId: isNaN(parsedId) ? propertyId : parsedId };
  return api.post(`/api/add-project-buy-later`, value);
};

const payForApartmentClass = (rentedApartmentClassId, tenure, pin) => {
  const value = {
    rentedApartmentClassId: Number(rentedApartmentClassId),
    tenure: Number(tenure),
    pin: pin.toString(),
  };
  return api.post(`/api/complete-payment-for-apartment-class`, value);
};

const renewRent = (rentedApartmentClassId, tenure, pin) => {
  const value = {
    rentedApartmentClassId: rentedApartmentClassId.toString(),
    tenure: Number(tenure),
    pin: pin.toString(),
  };
  return api.post(`/api/renew-rent`, value);
};

const removeProjectBuyLater = (propertyId) => {
  const value = { propertyId: propertyId.toString() };
  return api.post(`/api/remove-project-buy-later`, value);
};

const buyAirtime = (amount, pin, number, network, saveStatus) => {
  const value = {
    amount: amount,
    beneficiary: number,
    network: network,
    deviceId: "deviceId",
    transactionPin: pin,
    saveStatus: saveStatus,
  };
  return api.post(`/apibill/airtime`, value);
};

const buyData = (amount, pin, number, network, id, saveStatus) => {
  const value = {
    amount: amount,
    beneficiary: number,
    network: network,
    deviceId: "deviceId",
    transactionPin: pin,
    id: id,
    saveStatus: saveStatus,
  };
  return api.post(`/apibill/data`, value);
};

const purchaseSmeData = (amount, pin, number, id, saveStatus) => {
  const value = {
    amount: amount,
    phone_number: number,
    plan_id: id,
    transactionPin: pin,
    saveStatus: saveStatus,
  };
  return api.post(`/apibill/data`, value);
};

const purchaseElectricity = (
  amount,
  pin,
  service_type,
  account_number,
  phone,
) => {
  const value = {
    service_type: service_type,
    account_number: account_number,
    amount: amount,
    phone: phone,
    agentId: "205",
    transactionPin: pin,
  };
  return api.post(`/apibill/electricity-request`, value);
};

const nameLookupElectricity = (type, number) => {
  const value = {
    service_type: type,
    account_number: number,
  };
  return api.post(`/bills/verify-name-elec`, value);
};

const cablePriceList = (name) => {
  const value = { service_type: name };

  return api.post(`/bills/multichoice-list`, value);
};
const dstvNameLookup = (type, number) => {
  const value = {
    service_type: type,
    account_number: number,
  };
  return api.post(`/bills/look-up`, value);
};
const purchaseCable = (amount, pin, service_type, account_number, code) => {
  const value = {
    smartcard_number: account_number,
    total_amount: amount,
    product_code: code,
    product_monthsPaidFor: 1,
    service_type: service_type,
    agentId: "205",
    transactionPin: pin,
  };
  return api.post(`/apibill/cable-request`, value);
};

const uploadIdentityDocument = (document, documentType) => {
  const value = {
    document: document,
    documentType: documentType,
  };
  return api.post(`/api/upload-identity-document`, value);
};

const addApartmentBuyLater = (apartmentClassId) => {
  const value = { apartmentClassId: apartmentClassId };
  return api.post(`/api/add-apartment-buy-later`, value);
};

const removeApartmentFromBookmark = (apartmentClassId) => {
  const value = { apartmentClassId: apartmentClassId };
  return api.post(`/api/remove-apartment-from-bookmark`, value);
};

const requestWithdrawal = (amount, customerBankId) => {
  const value = { amount: amount, customerBankId: customerBankId };
  return api.post(`/api/request-withdrawal`, value);
};

const updateUserProfile = (profilePicture, phoneNumber) => {
  const value = {
    profilePicture: profilePicture,
    phoneNumber: phoneNumber,
  };
  return api.post(`/api/update-user-profile`, value);
};

const postService = {
  validateAccount,
  signupUser,
  verifyEmail,
  liquidate,
  setupTransactionPin,
  resendOtp,
  refreshToken: () => {
    return api.post(`/api/refreshToken`, {});
  },
  userLogin,

  createNextOfKin,
  bankInfo,
  changePin,
  changePassword,
  resetPassword,
  addBankAcc,
  deleteBankAcc: (bankCode, accountNumber, accountName, bankName) => {
    const value = {
      bankCode: bankCode,
      accountNumber: accountNumber,
      accountName: accountName,
      bankName: bankName,
    };
    return api.post(`/api/delete-customer-bank`, value);
  },
  forgetPin,
  resetPin,
  verifyBvn,
  validateBvn,
  requestToJoinApartment,
  fundWallet,
  Withdrawer,
  savings,
  buyProject,
  financeAListing,
  buyProperty,
  deAccount,
  saveProduct,
  addProjectBuyLater,
  removeProjectBuyLater,
  removePropertyBuyLater,
  getVirtualAcc,
  buyAirtime,
  buyData,
  purchaseSmeData,
  purchaseElectricity,
  nameLookupElectricity,
  cablePriceList,
  dstvNameLookup,
  purchaseCable,
  uploadIdentityDocument,
  payForApartmentClass,
  addApartmentBuyLater,
  removeApartmentFromBookmark,
  requestWithdrawal,
  updateUserProfile,
  renewRent,
  addPropertyBuyLater,
  requestVisit: (targetId, preferredDate, preferredTime) => {
    return api.post(`/api/request-visit`, {
      targetType: "PROPERTY",
      targetId: Number(targetId),
      preferredDate: preferredDate,
      preferredTime: preferredTime,
    });
  },
};

export default postService;
